/**
 * The tabs of the Audit page. The URL keeps the tab (`?tab=failures`), so a
 * notice can link straight to one. This sits outside the page so the router
 * can read it without loading the page.
 */

export const AUDIT_TABS = ["dashboard", "runs", "investigations", "failures", "procedure"] as const;
export type AuditTab = (typeof AUDIT_TABS)[number];

export function parseAuditSearch(search: Record<string, unknown>): { tab?: AuditTab } {
  return typeof search.tab === "string" && (AUDIT_TABS as readonly string[]).includes(search.tab)
    ? { tab: search.tab as AuditTab }
    : {};
}
